export default __webpack_public_path__ + "static/media/Montserrat-Medium.4b4a4b36.otf";